import { render, staticRenderFns } from "./HomepageCollectionsForm.vue?vue&type=template&id=f5307492&scoped=true&"
import script from "./HomepageCollectionsForm.vue?vue&type=script&lang=js&"
export * from "./HomepageCollectionsForm.vue?vue&type=script&lang=js&"
import style0 from "./HomepageCollectionsForm.vue?vue&type=style&index=0&id=f5307492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5307492",
  null
  
)

component.options.__file = "HomepageCollectionsForm.vue"
export default component.exports